import { atom } from 'recoil'

export const globalSearch = atom({
  key: 'newSearch',
  ticketNumber: '',
  userName: '',
  startDate: '',
  endDate: '',
  status: '',
  ticketCategoryId: '',
  subCategory: '',
  subSubCategory: '',
  nextViewHistory: '',
  default: false,
})
